import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import withLoader from 'components/organisms/withLoader';
import { format } from 'date-fns';
import {
  API_PATIENT_CALLS,
  API_PATIENT_CALL_RECORD,
} from 'services/dataService/ccmResources';
import C from 'classnames';
import Pagination from 'components/molecules/paginationTransition';
import useTable from 'utils/useTable';
import { useParams } from 'react-router-dom';
import DownloadIcon from 'components/atoms/icons/downloadIcon';
import { openInNewTab, showResult } from 'utils';
import dataService from 'services/dataService';

const downloadAudio = async (callId, patientGuid) => {
  const { error, data } = await dataService.getList(
    API_PATIENT_CALL_RECORD(patientGuid, callId),
  );

  if (error) {
    return showResult(error);
  }
  if (data && data.url) return openInNewTab(data.url);
};

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:s';
const PER_PAGE = 5;
const VoiceCallLogs = () => {
  const { patientGuid } = useParams();

  const dates = useSelector((state) => state.ccmPatientDetails.dates);

  const {
    data: { items },
    count,
    loading,
    page,
    setPage,
    setFilters,
  } = useTable(
    API_PATIENT_CALLS,
    PER_PAGE,
    { patientGuid },
    { makeInitialRequest: false },
  );

  useEffect(() => {
    if (dates.length > 1) {
      const startTime = format(dates[0], DATE_FORMAT);
      const endTime = format(dates[1], DATE_FORMAT);
      setFilters({ patientGuid, startTime, endTime });
    }
  }, [dates, patientGuid]);

  return (
    <>
      <h3 className="ccm-table-section__h4">Voice Calls Logged</h3>
      {withLoader(
        loading,
        <>
          <div className="table-outer table-custom-scrollbar">
            <table cellSpacing="0" cellPadding="0" className="table-border">
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Duration</th>
                  <th>Care Agent</th>
                  <th>Outcome</th>
                </tr>
              </thead>
              <tbody>
                {!!items.length &&
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {el.call.createdAt
                          ? format(new Date(el.call.createdAt), 'LLL dd yyyy p')
                          : ''}
                      </td>
                      <td>{el.call.duration}</td>
                      <td>
                        {`${el.author.title || ''} ${
                          el.author.firstName || ''
                        } ${el.author.lastName || ''} `}
                      </td>
                      <td
                        className={C('comment-audio-download', {
                          disabled: loading,
                        })}
                      >
                        {el.call.duration ? (
                          <div
                            className={C('ccm-table__button')}
                            onClick={() =>
                              downloadAudio(el.call.callId, patientGuid)
                            }
                          >
                            <DownloadIcon /> {`${el.call.callId}.mp3`}
                          </div>
                        ) : (
                          <div>n/a</div>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="ccm-table-section__pagination">
            <Pagination
              title=""
              page={page}
              pageTotal={items.length}
              itemsPerPage={PER_PAGE}
              total={count}
              handleFirstClick={() => setPage(1)}
              handleLastClick={() => setPage(Math.ceil(count / PER_PAGE))}
              handlePrevClick={() => setPage(page - 1)}
              handleNextClick={() => setPage(page + 1)}
              handleGoToPage={(numberPage) => setPage(numberPage)}
            />
          </div>
        </>,
      )}
    </>
  );
};

export default VoiceCallLogs;
